var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMakerdao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 112,
    viewBox: "0 0 160 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.007 15.0866V100.731H160V14.2466C160 12.2274 159.429 10.2702 158.376 8.58244C155.509 3.98774 149.649 2.51694 145.174 5.69936C145.172 5.70083 145.17 5.7023 145.168 5.70377L93.4563 42.3251L93.4506 42.3291C89.4571 45.174 87.1267 49.8159 87.1267 54.8793V100.638H97.1193V54.8793C97.1193 53.4207 97.7528 52.0995 98.9893 51.2166L98.9935 51.2137L150.007 15.0866Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1224 93.4617C94.9133 93.4617 97.0936 95.8848 97.0936 98.7738V102.688C97.0936 105.67 94.826 108 92.1224 108C89.3316 108 87.1513 105.577 87.1513 102.688V98.7738C87.0641 95.7916 89.3316 93.4617 92.1224 93.4617Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.83 93.4617C157.621 93.4617 159.801 95.8848 159.801 98.7738V102.688C159.801 105.67 157.534 108 154.83 108C152.039 108 149.859 105.577 149.859 102.688V98.7738C149.859 95.7916 152.126 93.4617 154.83 93.4617Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8255 5.69914C14.8277 5.70068 14.8299 5.70223 14.832 5.70377L66.5438 42.3251L66.5494 42.3291C70.5429 45.174 72.8733 49.8159 72.8733 54.8793V100.638H62.8807V54.8793C62.8807 53.4206 62.2472 52.0993 61.0104 51.2164L61.0065 51.2137L9.99262 15.0866V100.731H0V14.2466C0 12.2274 0.57111 10.2702 1.62405 8.58244C4.49053 3.98784 10.351 2.51701 14.8255 5.69914Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08357 93.4617C7.87439 93.4617 10.0547 95.8848 10.0547 98.7738V102.688C10.0547 105.67 7.78718 108 5.08357 108C2.29275 108 0.112423 105.577 0.112423 102.688V98.7738C0.112423 95.7916 2.29275 93.4617 5.08357 93.4617Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8778 93.4617C70.6686 93.4617 72.8489 95.8848 72.8489 98.7738V102.688C72.8489 105.67 70.5814 108 67.8778 108C65.087 108 62.9066 105.577 62.9066 102.688V98.7738C62.8194 95.7916 65.087 93.4617 67.8778 93.4617Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakerdao);
export default __webpack_public_path__ + "static/media/makerdao.503aee4c80ec43bfcada1b69142cae37.svg";
export { ForwardRef as ReactComponent };